export * from './detailed-claim-condition-dread';
export const DetailedClaimConditions = [
    {
        value:
            'Activities of Daily Living catch-all - Permanent inability to perform 1 or more Basic ADLs, and permanent inability to perform 2 or more Instrumental ADLs',
        label:
            'Activities of Daily Living catch-all - Permanent inability to perform 1 or more Basic ADLs, and permanent inability to perform 2 or more Instrumental ADLs',
        Category:
            'Activities of Daily Living catch-all - Permanent inability to perform 1 or more Basic ADLs, and permanent inability to perform 2 or more Instrumental ADLs',
    },
    {
        value:
            'Activities of Daily Living catch-all - Permanent inability to perform 3 or more Basic ADLs, and permanent inability to perform 4 or more Instrumental ADLs',
        label:
            'Activities of Daily Living catch-all - Permanent inability to perform 3 or more Basic ADLs, and permanent inability to perform 4 or more Instrumental ADLs',
        Category:
            'Activities of Daily Living catch-all - Permanent inability to perform 3 or more Basic ADLs, and permanent inability to perform 4 or more Instrumental ADLs',
    },
    {
        value:
            'Anaemia - Persistent haemoglobin levels of 8g/dl or less and transfusions of at least 2 units of blood required every 2 weeks.',
        label:
            'Anaemia - Persistent haemoglobin levels of 8g/dl or less and transfusions of at least 2 units of blood required every 2 weeks.',
        Category:
            'Anaemia - Persistent haemoglobin levels of 8g/dl or less and transfusions of at least 2 units of blood required every 2 weeks.',
    },
    {
        value:
            'Anaemia - Persistent haemoglobin levels of 8g/dl or less and transfusions of at least 2 units of blood required every 6 weeks',
        label:
            'Anaemia - Persistent haemoglobin levels of 8g/dl or less and transfusions of at least 2 units of blood required every 6 weeks',
        Category:
            'Anaemia - Persistent haemoglobin levels of 8g/dl or less and transfusions of at least 2 units of blood required every 6 weeks',
    },
    {
        value:
            'Anorectal disease - Complete and permanent faecal incontinence not amenable to colostomy',
        label:
            'Anorectal disease - Complete and permanent faecal incontinence not amenable to colostomy',
        Category:
            'Anorectal disease - Complete and permanent faecal incontinence not amenable to colostomy',
    },
    {
        value:
            'Anorectal disease - Complete and permanent faecal incontinence treated with permanent colostomy',
        label:
            'Anorectal disease - Complete and permanent faecal incontinence treated with permanent colostomy',
        Category:
            'Anorectal disease - Complete and permanent faecal incontinence treated with permanent colostomy',
    },
    {
        value: 'Anorectal disease - Partial but permanent faecal incontinence',
        label: 'Anorectal disease - Partial but permanent faecal incontinence',
        Category: 'Anorectal disease - Partial but permanent faecal incontinence',
    },
    {
        value:
            'Aphasia/dysphasia - Complete inability to comprehend language symbols as a result of injury to, or disease of the brain as confirmed by a neurologist or other appropriate specialist.',
        label:
            'Aphasia/dysphasia - Complete inability to comprehend language symbols as a result of injury to, or disease of the brain as confirmed by a neurologist or other appropriate specialist.',
        Category: 'Aphasia/dysphasia - Receptive aphasia or dysphasia',
    },
    {
        value:
            'Aphasia/dysphasia - Partial inability to comprehend language symbols as a result of injury to, or disease of the brain as confirmed by a neurologist or other appropriate specialist',
        label:
            'Aphasia/dysphasia - Partial inability to comprehend language symbols as a result of injury to, or disease of the brain as confirmed by a neurologist or other appropriate specialist',
        Category: 'Aphasia/dysphasia - Receptive aphasia or dysphasia',
    },
    {
        value:
            'Arrhythmias - Symptoms present must include: palpitations, light-headedness, presyncope or sustained reduced cardiac output despite appropriate surgical treatment or where surgery is contraindicated',
        label:
            'Arrhythmias - Symptoms present must include: palpitations, light-headedness, presyncope or sustained reduced cardiac output despite appropriate surgical treatment or where surgery is contraindicated',
        Category:
            'Arrhythmias - Symptoms are present continually and documented on Holter ECG and NYHA IV',
    },
    {
        value:
            'Arrhythmias - Symptoms present must include: palpitations, light-headedness, presyncope or sustained reduced cardiac output despite appropriate surgical treatment or where surgery is contraindicated',
        label:
            'Arrhythmias - Symptoms present must include: palpitations, light-headedness, presyncope or sustained reduced cardiac output despite appropriate surgical treatment or where surgery is contraindicated',
        Category:
            'Arrhythmias - Symptoms are present frequently and documented on Holter ECG and NYHA III',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage I',
        label: 'BCC: Basal cell skin carcinoma: Stage I',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage I',
        label: 'BCC: Basal cell skin carcinoma: Stage I',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage II',
        label: 'BCC: Basal cell skin carcinoma: Stage II',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage II',
        label: 'BCC: Basal cell skin carcinoma: Stage II',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage III',
        label: 'BCC: Basal cell skin carcinoma: Stage III',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage III',
        label: 'BCC: Basal cell skin carcinoma: Stage III',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage IV',
        label: 'BCC: Basal cell skin carcinoma: Stage IV',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'BCC: Basal cell skin carcinoma: Stage IV',
        label: 'BCC: Basal cell skin carcinoma: Stage IV',
        Category: 'Cancer and leukaemia - BCC',
    },
    {
        value: 'Biliary tract - With recurrent cholangitis and bilirubin greater than 34μmol/l',
        label: 'Biliary tract - With recurrent cholangitis and bilirubin greater than 34μmol/l',
        Category: 'Biliary tract - Irreparable biliary tract obstruction',
    },
    {
        value: 'Biliary tract - With recurrent cholangitis and bilirubin greater than 50μmol/l',
        label: 'Biliary tract - With recurrent cholangitis and bilirubin greater than 50μmol/l',
        Category: 'Biliary tract - Irreparable biliary tract obstruction',
    },
    {
        value: 'Bladder - Surgical removal of the bladder',
        label: 'Bladder - Surgical removal of the bladder',
        Category: 'Bladder - Surgical removal of the bladder',
    },
    {
        value:
            'Bladder - Total urinary incontinence, loss of reflex or voluntary urine control despite medical and surgical treatment',
        label:
            'Bladder - Total urinary incontinence, loss of reflex or voluntary urine control despite medical and surgical treatment',
        Category:
            'Bladder - Total urinary incontinence, loss of reflex or voluntary urine control despite medical and surgical treatment',
    },
    {
        value: 'Bladder cancer: Stage I',
        label: 'Bladder cancer: Stage I',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage I',
        label: 'Bladder cancer: Stage I',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage II',
        label: 'Bladder cancer: Stage II',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage II',
        label: 'Bladder cancer: Stage II',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage III',
        label: 'Bladder cancer: Stage III',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage III',
        label: 'Bladder cancer: Stage III',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage IV',
        label: 'Bladder cancer: Stage IV',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Bladder cancer: Stage IV',
        label: 'Bladder cancer: Stage IV',
        Category: 'Cancer and leukaemia - Bladder cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Acute Lymphoblastic Leukaemia (ALL)',
        label: 'Blood/bone marrow cancer: Acute Lymphoblastic Leukaemia (ALL)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Acute Lymphoblastic Leukaemia (ALL)',
        label: 'Blood/bone marrow cancer: Acute Lymphoblastic Leukaemia (ALL)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Acute Myeloblastic Leukaemia (AML)',
        label: 'Blood/bone marrow cancer: Acute Myeloblastic Leukaemia (AML)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Acute Myeloblastic Leukaemia (AML)',
        label: 'Blood/bone marrow cancer: Acute Myeloblastic Leukaemia (AML)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage 0 on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage 0 on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage 0 on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage 0 on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage I on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage I on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage I on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage I on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage II on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage II on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage II on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage II on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage III on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage III on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage III on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage III on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage IV on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage IV on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage IV on the Rai classification system',
        label:
            'Blood/bone marrow cancer: Chronic Lymphocytic Leukaemia: Stage IV on the Rai classification system',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia (no bone marrow transplantation)',
        label:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia (no bone marrow transplantation)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia (no bone marrow transplantation)',
        label:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia (no bone marrow transplantation)',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia: having undergone bone marrow transplant',
        label:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia: having undergone bone marrow transplant',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia: having undergone bone marrow transplant',
        label:
            'Blood/bone marrow cancer: Chronic Myeloid Leukaemia: having undergone bone marrow transplant',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Hairy cell leukaemia',
        label: 'Blood/bone marrow cancer: Hairy cell leukaemia',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Blood/bone marrow cancer: Hairy cell leukaemia',
        label: 'Blood/bone marrow cancer: Hairy cell leukaemia',
        Category: 'Cancer and leukaemia - Blood/bone marrow cancer',
    },
    {
        value: 'Brain tumour: Grade 2 on WHO classification',
        label: 'Brain tumour: Grade 2 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value: 'Brain tumour: Grade 2 on WHO classification',
        label: 'Brain tumour: Grade 2 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value: 'Brain tumour: Grade 3 on WHO classification',
        label: 'Brain tumour: Grade 3 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value: 'Brain tumour: Grade 3 on WHO classification',
        label: 'Brain tumour: Grade 3 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value: 'Brain tumour: Grade 4 on WHO classification',
        label: 'Brain tumour: Grade 4 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value: 'Brain tumour: Grade 4 on WHO classification',
        label: 'Brain tumour: Grade 4 on WHO classification',
        Category: 'Cancer and leukaemia - Brain cancer',
    },
    {
        value:
            'Breast cancer: Partial mastectomy for ductal or lobular carcinoma-in-situ of at least 50% of affected breast tissue in one breast.',
        label:
            'Breast cancer: Partial mastectomy for ductal or lobular carcinoma-in-situ of at least 50% of affected breast tissue in one breast.',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value:
            'Breast cancer: Partial mastectomy for ductal or lobular carcinoma-in-situ of at least 50% of affected breast tissue in one breast.',
        label:
            'Breast cancer: Partial mastectomy for ductal or lobular carcinoma-in-situ of at least 50% of affected breast tissue in one breast.',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage I',
        label: 'Breast cancer: Stage I',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage I',
        label: 'Breast cancer: Stage I',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage II',
        label: 'Breast cancer: Stage II',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage II',
        label: 'Breast cancer: Stage II',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage III',
        label: 'Breast cancer: Stage III',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage III',
        label: 'Breast cancer: Stage III',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage IV',
        label: 'Breast cancer: Stage IV',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Breast cancer: Stage IV',
        label: 'Breast cancer: Stage IV',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value:
            'Breast cancer: Total mastectomy for ductal or lobular carcinoma-in-situ of the breast',
        label:
            'Breast cancer: Total mastectomy for ductal or lobular carcinoma-in-situ of the breast',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value:
            'Breast cancer: Total mastectomy for ductal or lobular carcinoma-in-situ of the breast',
        label:
            'Breast cancer: Total mastectomy for ductal or lobular carcinoma-in-situ of the breast',
        Category: 'Cancer and leukaemia - Breast cancer',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        label: 'Cancer Claim Booster- Life expectancy is reduced to less than twelve (12) months.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        label:
            'Cancer Claim Booster- The cancer has progressed despite completion of all lines of available treatment as per gold standard treatment protocols. Progression, for the purpose of this benefit, is defined an increased tumour burden.',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Acute myeloblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Hodgkins or Non-Hodgkins lymphoma (stage III or IV on Ann Arbor classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Chronic lymphocytic leukaemia (stage III or IV on the Very High Risk CLL-IPI, Binet C or Rai classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Chronic myeloid leukaemia (having undergone bone marrow transplant)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Acute lymphoblastic leukaemia',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Multiple myeloma (stage III on the Durie-Salmon Scale)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Brain tumour (grade 3 or 4 on WHO classification)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Basal cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category: 'Cancer Claim Booster - Squamous cell skin carcinoma (stage IV)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Prostate cancer - T4N0M0 (any grade) or prostate cancer with lymph node involvement or metastases (At least N1 in TNM classification system)',
    },
    {
        value:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        label:
            'Cancer Claim Booster- There is a recurrence of the cancer, previously meeting the criterion above, after a period of remission. Remission, for the purpose of this benefit, is defined as a minimum period of 12 months that the claimant has been cancer or tumour free subsequent to treatment completion.',
        Category:
            'Cancer Claim Booster - Any other stage III or IV cancer, unless included in any of the criteria set out in any of the rows above',
    },
    {
        value: 'Carcinoid: Carcinoid syndrome/tumour',
        label: 'Carcinoid: Carcinoid syndrome/tumour',
        Category: 'Cancer and leukaemia - Carcinoid',
    },
    {
        value: 'Carcinoid: Carcinoid syndrome/tumour',
        label: 'Carcinoid: Carcinoid syndrome/tumour',
        Category: 'Cancer and leukaemia - Carcinoid',
    },
    {
        value:
            'Cardiovascular system - Receiving optimal treatment, but still symptomatic NYHA class 4, with METS < 3 or EF < 40%',
        label:
            'Cardiovascular system - Receiving optimal treatment, but still symptomatic NYHA class 4, with METS < 3 or EF < 40%',
        Category:
            'Cardiovascular system - Receiving optimal treatment, but still symptomatic NYHA class 4, with METS < 3 or EF < 40%',
    },
    {
        value: 'Cervical cancer: Stage I',
        label: 'Cervical cancer: Stage I',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage I',
        label: 'Cervical cancer: Stage I',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage II',
        label: 'Cervical cancer: Stage II',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage II',
        label: 'Cervical cancer: Stage II',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage III',
        label: 'Cervical cancer: Stage III',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage III',
        label: 'Cervical cancer: Stage III',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage IV',
        label: 'Cervical cancer: Stage IV',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value: 'Cervical cancer: Stage IV',
        label: 'Cervical cancer: Stage IV',
        Category: 'Cancer and leukaemia - Cervical cancer',
    },
    {
        value:
            'Clotting disorders - Bleeds or clots which have resulted in documented permanent end-organ dysfunction or damage in spite of surgical or medical treatment',
        label:
            'Clotting disorders - Bleeds or clots which have resulted in documented permanent end-organ dysfunction or damage in spite of surgical or medical treatment',
        Category:
            'Clotting disorders - Bleeds or clots which have resulted in documented permanent end-organ dysfunction or damage in spite of surgical or medical treatment',
    },
    {
        value: 'Colorectal cancer: Stage I',
        label: 'Colorectal cancer: Stage I',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage I',
        label: 'Colorectal cancer: Stage I',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage II',
        label: 'Colorectal cancer: Stage II',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage II',
        label: 'Colorectal cancer: Stage II',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage III',
        label: 'Colorectal cancer: Stage III',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage III',
        label: 'Colorectal cancer: Stage III',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage IV',
        label: 'Colorectal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value: 'Colorectal cancer: Stage IV',
        label: 'Colorectal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Colorectal cancer',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of rheumatoid arthritis undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of rheumatoid arthritis undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of rheumatoid arthritis undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of rheumatoid arthritis undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of rheumatoid arthritis undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of rheumatoid arthritis undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of sarcoidosis undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of sarcoidosis undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of sarcoidosis undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of sarcoidosis undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of sarcoidosis undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of sarcoidosis undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of systemic lupus erythematosus undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of systemic lupus erythematosus undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of systemic lupus erythematosus undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of systemic lupus erythematosus undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of systemic lupus erythematosus undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of systemic lupus erythematosus undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of systemic scleroderma undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of systemic scleroderma undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of systemic scleroderma undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of systemic scleroderma undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of systemic scleroderma undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of systemic scleroderma undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of Wegener’s granulomatosis undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of Wegener’s granulomatosis undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of Wegener’s granulomatosis undergoing appropriate treatment',
    },
    {
        value:
            'Connective Tissue Disorders - On diagnosis of Wegener’s granulomatosis undergoing appropriate treatment',
        label:
            'Connective Tissue Disorders - On diagnosis of Wegener’s granulomatosis undergoing appropriate treatment',
        Category:
            'Connective Tissue Disorders - On diagnosis of Wegener’s granulomatosis undergoing appropriate treatment',
    },
    {
        value:
            'Coronary artery disease - Assessed on occurrence of a myocardial infarction (heart attack), coronary artery bypass graft surgery (CABG) or angioplasty with or without stenting',
        label:
            'Coronary artery disease - Assessed on occurrence of a myocardial infarction (heart attack), coronary artery bypass graft surgery (CABG) or angioplasty with or without stenting',
        Category: 'Coronary artery disease - EF 35-40%',
    },
    {
        value: 'Coronary artery disease - EF less than 45%',
        label: 'Coronary artery disease - EF less than 45%',
        Category: 'Coronary artery disease - EF less than 45%',
    },
    {
        value: 'Coronary artery disease - METS 5 or less',
        label: 'Coronary artery disease - METS 5 or less',
        Category: 'Coronary artery disease - METS 5 or less',
    },
    {
        value: 'Coronary artery disease - NYHA III or greater',
        label: 'Coronary artery disease - NYHA III or greater',
        Category: 'Coronary artery disease - NYHA III or greater',
    },
    {
        value:
            'Cranial nerve IX, X, XII (glossopharyngeal, vagal, hypoglossal nerves) - Inability to swallow, requiring regular suctioning to prevent aspiration or choking',
        label:
            'Cranial nerve IX, X, XII (glossopharyngeal, vagal, hypoglossal nerves) - Inability to swallow, requiring regular suctioning to prevent aspiration or choking',
        Category:
            'Cranial nerve IX, X, XII (glossopharyngeal, vagal, hypoglossal nerves) - Inability to swallow, requiring regular suctioning to prevent aspiration or choking',
    },
    {
        value:
            'Cranial nerve IX, X, XII (glossopharyngeal, vagal, hypoglossal nerves) - Moderate to severe dysarthria or dysphasia, nasal regurgitation and aspiration',
        label:
            'Cranial nerve IX, X, XII (glossopharyngeal, vagal, hypoglossal nerves) - Moderate to severe dysarthria or dysphasia, nasal regurgitation and aspiration',
        Category:
            'Cranial nerve IX, X, XII (glossopharyngeal, vagal, hypoglossal nerves) - Moderate to severe dysarthria or dysphasia, nasal regurgitation and aspiration',
    },
    {
        value:
            'Cranial nerve V (trigeminal nerve) - Severe uncontrolled unilateral or bilateral facial neuralgic pain affecting either speech or eating',
        label:
            'Cranial nerve V (trigeminal nerve) - Severe uncontrolled unilateral or bilateral facial neuralgic pain affecting either speech or eating',
        Category:
            'Cranial nerve V (trigeminal nerve) - Severe uncontrolled unilateral or bilateral facial neuralgic pain affecting either speech or eating',
    },
    {
        value:
            'Cranial nerve VII (facial nerve) - Unilateral or bilateral facial nerve paralysis with the inability to control eyelid closure',
        label:
            'Cranial nerve VII (facial nerve) - Unilateral or bilateral facial nerve paralysis with the inability to control eyelid closure',
        Category:
            'Cranial nerve VII (facial nerve) - Unilateral or bilateral facial nerve paralysis with the inability to control eyelid closure',
    },
    {
        value:
            'Cranial nerve VIII (vestibulocochlear nerve) - Inability to communicate in a group with documented tinnitus induced hearing loss and presence of symptoms listed below leading to the inability to climb stairs or walk unaided by another person, with abnormal findings on electronystagmography or videonystagmography. * Frequent nausea and vomiting documented weekly * Vertigo with uncoordinated movement and * Inability to balance.',
        label:
            'Cranial nerve VIII (vestibulocochlear nerve) - Inability to communicate in a group with documented tinnitus induced hearing loss and presence of symptoms listed below leading to the inability to climb stairs or walk unaided by another person, with abnormal findings on electronystagmography or videonystagmography. * Frequent nausea and vomiting documented weekly * Vertigo with uncoordinated movement and * Inability to balance.',
        Category:
            'Cranial nerve VIII (vestibulocochlear nerve) - Inability to communicate in a group with documented tinnitus induced hearing loss and presence of symptoms leading to the inability to climb stairs or walk unaided by another person, with abnormal findings on electronystagmography or videonystagmography.',
    },
    {
        value:
            'Cranial nerve VIII (vestibulocochlear nerve) - Inability to communicate in a group with documented tinnitus induced hearing loss and the presence of the following symptoms:frequent nausea and vomiting documented weekly and vertigo with uncoordinated movement and inability to balance.',
        label:
            'Cranial nerve VIII (vestibulocochlear nerve) - Inability to communicate in a group with documented tinnitus induced hearing loss and the presence of the following symptoms:frequent nausea and vomiting documented weekly and vertigo with uncoordinated movement and inability to balance.',
        Category:
            'Cranial nerve VIII (vestibulocochlear nerve) - Inability to communicate in a group with documented tinnitus induced hearing loss and the presence of listed symptoms',
    },
    {
        value:
            'Diplegia / paraplegia - Total loss or total loss of use of two lower limbs due to a central nervous system disease, disorder or injury',
        label:
            'Diplegia / paraplegia - Total loss or total loss of use of two lower limbs due to a central nervous system disease, disorder or injury',
        Category: 'Diplegia / paraplegia - Permanent diplegia / paraplegia',
    },
    {
        value:
            'Diseases of the aorta - Symptoms include intermittent caludication, inappropriate limb fatigue and pain, and thromboembolic disease (gangrene)',
        label:
            'Diseases of the aorta - Symptoms include intermittent caludication, inappropriate limb fatigue and pain, and thromboembolic disease (gangrene)',
        Category: 'Diseases of the aorta - Persistent symptoms despite medication and NYHA III',
    },
    {
        value:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 40mm Hg with NYHA III',
        label:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 40mm Hg with NYHA III',
        Category:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 40mm Hg with NYHA III',
    },
    {
        value:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 40mm Hg with right heart failure',
        label:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 40mm Hg with right heart failure',
        Category:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 40mm Hg with right heart failure',
    },
    {
        value:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 70mm Hg with NYHA IV',
        label:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 70mm Hg with NYHA IV',
        Category:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 70mm Hg with NYHA IV',
    },
    {
        value:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 70mm Hg with right heart failure',
        label:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 70mm Hg with right heart failure',
        Category:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure greater than 70mm Hg with right heart failure',
    },
    {
        value:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure of 40-70mm Hg with NYHA III',
        label:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure of 40-70mm Hg with NYHA III',
        Category:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure of 40-70mm Hg with NYHA III',
    },
    {
        value:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure of 40-70mm Hg with right heart failure',
        label:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure of 40-70mm Hg with right heart failure',
        Category:
            'Diseases of the pulmonary arteries - Systolic Pulmonary Artery Pressure of 40-70mm Hg with right heart failure',
    },
    {
        value: 'Endometrial cancer: Stage I',
        label: 'Endometrial cancer: Stage I',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage I',
        label: 'Endometrial cancer: Stage I',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage II',
        label: 'Endometrial cancer: Stage II',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage II',
        label: 'Endometrial cancer: Stage II',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage III',
        label: 'Endometrial cancer: Stage III',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage III',
        label: 'Endometrial cancer: Stage III',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage IV',
        label: 'Endometrial cancer: Stage IV',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value: 'Endometrial cancer: Stage IV',
        label: 'Endometrial cancer: Stage IV',
        Category: 'Cancer and leukaemia - Endometrial cancer',
    },
    {
        value:
            'Episodic loss of consciousness - 12 or more Grand Mal seizures per month for 4 or more consecutive months in spite of sustained optimal treatment and documented compliance of that treatment',
        label:
            'Episodic loss of consciousness - 12 or more Grand Mal seizures per month for 4 or more consecutive months in spite of sustained optimal treatment and documented compliance of that treatment',
        Category: 'Episodic loss of consciousness - Seizures',
    },
    {
        value:
            'Episodic loss of consciousness - 6 or more Grand Mal seizures per month for 4 or more consecutive months in spite of sustained optimal treatment and documented compliance to that treatment',
        label:
            'Episodic loss of consciousness - 6 or more Grand Mal seizures per month for 4 or more consecutive months in spite of sustained optimal treatment and documented compliance to that treatment',
        Category: 'Episodic loss of consciousness - Seizures',
    },
    {
        value:
            'Episodic loss of consciousness - At least 3 documented episodes of Status Epilepticus requiring emergency medical treatment within the last 12 months',
        label:
            'Episodic loss of consciousness - At least 3 documented episodes of Status Epilepticus requiring emergency medical treatment within the last 12 months',
        Category: 'Episodic loss of consciousness - Status epilepticus',
    },
    {
        value: 'Eye cancer: Stage I',
        label: 'Eye cancer: Stage I',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage I',
        label: 'Eye cancer: Stage I',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage II',
        label: 'Eye cancer: Stage II',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage II',
        label: 'Eye cancer: Stage II',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage III',
        label: 'Eye cancer: Stage III',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage III',
        label: 'Eye cancer: Stage III',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage IV',
        label: 'Eye cancer: Stage IV',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value: 'Eye cancer: Stage IV',
        label: 'Eye cancer: Stage IV',
        Category: 'Cancer and leukaemia - Eye cancer',
    },
    {
        value:
            'Face - Disfigurement due to the destruction of the bones or tissues and absence of normal anatomic part or area of the face (e.g. the nose) with resulting cosmetic deformity',
        label:
            'Face - Disfigurement due to the destruction of the bones or tissues and absence of normal anatomic part or area of the face (e.g. the nose) with resulting cosmetic deformity',
        Category: 'Face - Disfigurement',
    },
    {
        value:
            'Gait disorders/motor coordination - Difficulty with grasping, pincer grip, fine or gross motor coordination or grip strength',
        label:
            'Gait disorders/motor coordination - Difficulty with grasping, pincer grip, fine or gross motor coordination or grip strength',
        Category:
            'Gait disorders/motor coordination - Difficulty with grasping, pincer grip, fine or gross motor coordination or grip strength',
    },
    {
        value:
            'Gait disorders/motor coordination - Difficulty with standing, maintaining a standing position and needing assistance with walking',
        label:
            'Gait disorders/motor coordination - Difficulty with standing, maintaining a standing position and needing assistance with walking',
        Category:
            'Gait disorders/motor coordination - Difficulty with standing, maintaining a standing position and needing assistance with walking',
    },
    {
        value:
            'Gait disorders/motor coordination - Needing assistive devices or mechanical support for daily functions and documented previous falls and inability to stand, walk, stoop, squat, kneel, climb stairs',
        label:
            'Gait disorders/motor coordination - Needing assistive devices or mechanical support for daily functions and documented previous falls and inability to stand, walk, stoop, squat, kneel, climb stairs',
        Category:
            'Gait disorders/motor coordination - Needing assistive devices or mechanical support for daily functions and documented previous falls and inability to stand, walk, stoop, squat, kneel, climb stairs',
    },
    {
        value:
            'Gait disorders/motor coordination - Needing assistive devices or mechanical support for daily functions and inability to grasp, pincer grip and inability with fine or gross motor coordination or grip strength',
        label:
            'Gait disorders/motor coordination - Needing assistive devices or mechanical support for daily functions and inability to grasp, pincer grip and inability with fine or gross motor coordination or grip strength',
        Category:
            'Gait disorders/motor coordination - Needing assistive devices or mechanical support for daily functions and inability to grasp, pincer grip and inability with fine or gross motor coordination or grip strength',
    },
    {
        value:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
        label:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
        Category:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
    },
    {
        value:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
        label:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
        Category:
            'Gastrointestinal disease - On diagnosis of ulcerative colitis undergoing appropriate treatment',
    },
    {
        value:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
        label:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
        Category:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
    },
    {
        value:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
        label:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
        Category:
            "Gastrointestinal disease -On diagnosis of Crohn's disease undergoing appropriate treatment",
    },
    {
        value:
            'Hearing - In both ears between 70-87dB (per ear) in 2 measurements at least 6 months apart',
        label:
            'Hearing - In both ears between 70-87dB (per ear) in 2 measurements at least 6 months apart',
        Category: 'Hearing - Total and irreversible average hearing loss',
    },
    {
        value:
            'Hearing - In both ears greater than 87dB (per ear) in 2 measurements at least 6 months apart',
        label:
            'Hearing - In both ears greater than 87dB (per ear) in 2 measurements at least 6 months apart',
        Category: 'Hearing - Total and irreversible average hearing loss',
    },
    {
        value:
            'Hearing - In one ear of greater than 70dB in 2 measurements at least 6 months apart',
        label:
            'Hearing - In one ear of greater than 70dB in 2 measurements at least 6 months apart',
        Category: 'Hearing - Total and irreversible average hearing loss',
    },
    {
        value: 'Heart transplant - A heart transplant',
        label: 'Heart transplant - A heart transplant',
        Category: 'Heart transplant - Heart transplant',
    },
    {
        value:
            'Hemiplegia - Total loss or total loss of use of two limbs on the same side of the body due to a central nervous system disease, disorder or injury',
        label:
            'Hemiplegia - Total loss or total loss of use of two limbs on the same side of the body due to a central nervous system disease, disorder or injury',
        Category: 'Hemiplegia - Permanent hemiplegia',
    },
    {
        value:
            'Hernia - Persistent, irreducible or irreparable protrusion of hernia and development of ongoing complications (strangulations, obstructions, ischaemia and gangrene)',
        label:
            'Hernia - Persistent, irreducible or irreparable protrusion of hernia and development of ongoing complications (strangulations, obstructions, ischaemia and gangrene)',
        Category:
            'Hernia - Persistent, irreducible or irreparable protrusion of hernia and development of ongoing complications (strangulations, obstructions, ischaemia and gangrene)',
    },
    {
        value:
            'Hernia - Persistent, irreducible or irreparable protrusion of hernia and development of ongoing complications, as specified in the policy document, and weight loss resulting in a BMI of less than 14.5.',
        label:
            'Hernia - Persistent, irreducible or irreparable protrusion of hernia and development of ongoing complications, as specified in the policy document, and weight loss resulting in a BMI of less than 14.5.',
        Category:
            'Hernia - Persistent, irreducible or irreparable protrusion of hernia and development of ongoing complications, as specified in the policy document, and weight loss resulting in a BMI of less than 14.5.',
    },
    {
        value:
            'Hypertensive cardiovascular disease - Documented Stage 3 hypertension despite treatment over at least a 3 month period and left ventricular hypertrophy',
        label:
            'Hypertensive cardiovascular disease - Documented Stage 3 hypertension despite treatment over at least a 3 month period and left ventricular hypertrophy',
        Category: 'Hypertensive cardiovascular disease - Documented Stage 3 hypertension',
    },
    {
        value: 'Hypertensive cardiovascular disease - Renal system impairment with GFR 24-40ml/min',
        label: 'Hypertensive cardiovascular disease - Renal system impairment with GFR 24-40ml/min',
        Category: 'Hypertensive cardiovascular disease - Renal system impairment',
    },
    {
        value:
            'Hypertensive cardiovascular disease - Renal system impairment with GFR less than 24ml/min with central nervous system damage',
        label:
            'Hypertensive cardiovascular disease - Renal system impairment with GFR less than 24ml/min with central nervous system damage',
        Category: 'Hypertensive cardiovascular disease - Renal system impairment',
    },
    {
        value:
            'Hypertensive cardiovascular disease - Renal system impairment with GFR less than 24ml/min with NYHA IV',
        label:
            'Hypertensive cardiovascular disease - Renal system impairment with GFR less than 24ml/min with NYHA IV',
        Category: 'Hypertensive cardiovascular disease - Renal system impairment',
    },
    {
        value:
            'Hypertensive cardiovascular disease - Renal system impairment with GFR less than 40ml/min',
        label:
            'Hypertensive cardiovascular disease - Renal system impairment with GFR less than 40ml/min',
        Category: 'Hypertensive cardiovascular disease - Renal system impairment',
    },
    {
        value: 'Impairment of consciousness - Irreversible coma requiring total medical support',
        label: 'Impairment of consciousness - Irreversible coma requiring total medical support',
        Category: 'Impairment of consciousness - Coma',
    },
    {
        value:
            'Impairment of consciousness - Stabilised Glasgow Coma Scale score of less than 9 for at least five days',
        label:
            'Impairment of consciousness - Stabilised Glasgow Coma Scale score of less than 9 for at least five days',
        Category: 'Impairment of consciousness - Coma',
    },
    {
        value: 'Liver cancer: Stage I',
        label: 'Liver cancer: Stage I',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage I',
        label: 'Liver cancer: Stage I',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage II',
        label: 'Liver cancer: Stage II',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage II',
        label: 'Liver cancer: Stage II',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage III',
        label: 'Liver cancer: Stage III',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage III',
        label: 'Liver cancer: Stage III',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage IV',
        label: 'Liver cancer: Stage IV',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value: 'Liver cancer: Stage IV',
        label: 'Liver cancer: Stage IV',
        Category: 'Cancer and leukaemia - Liver cancer',
    },
    {
        value:
            'Liver disease - Abnormal liver function tests, as evidenced by at least two of the following: - Albumin 28-35mg/L - INR 1.71-2.20 - Bilirubin 34-50μmol/l - Ascites.',
        label:
            'Liver disease - Abnormal liver function tests, as evidenced by at least two of the following: - Albumin 28-35mg/L - INR 1.71-2.20 - Bilirubin 34-50μmol/l - Ascites.',
        Category: 'Liver disease - Abnormal liver function tests',
    },
    {
        value:
            'Liver disease - Abnormal liver function tests, as evidenced by at least two of the following: - Albumin less than 28mg/L - INR greater than 2.20 - Bilirubin 34-50μmol/l - Ascites.',
        label:
            'Liver disease - Abnormal liver function tests, as evidenced by at least two of the following: - Albumin less than 28mg/L - INR greater than 2.20 - Bilirubin 34-50μmol/l - Ascites.',
        Category: 'Liver disease - Abnormal liver function tests',
    },
    {
        value:
            'Liver disease - Abnormal liver function tests, as evidenced by at least two of the following: - Albumin less than 28mg/L - INR greater than 2.20 - Bilirubin greater than 50μmol/l - Ascites.',
        label:
            'Liver disease - Abnormal liver function tests, as evidenced by at least two of the following: - Albumin less than 28mg/L - INR greater than 2.20 - Bilirubin greater than 50μmol/l - Ascites.',
        Category: 'Liver disease - Abnormal liver function tests',
    },
    {
        value:
            'Liver disease - Abnormal liver function tests, as evidenced by at least two of the following: - Albumin less than 35mg/L - INR greater than 1.71 - Bilirubin greater than 34μmol/l - Ascites.',
        label:
            'Liver disease - Abnormal liver function tests, as evidenced by at least two of the following: - Albumin less than 35mg/L - INR greater than 1.71 - Bilirubin greater than 34μmol/l - Ascites.',
        Category: 'Liver disease - Abnormal liver function tests',
    },
    {
        value:
            'Liver disease - Persistent jaundice and bleeding varices and central nervous system manifestations of hepatoxicity including history of or on-going encephalopathy and severe symptoms and signs uncontrolled by medical or surgical treatment as evidenced by at least two of the following: - Albumin less than 28mg/L - INR greater than 2.20 - Bilirubin greater than 50μmol/l - Ascites.',
        label:
            'Liver disease - Persistent jaundice and bleeding varices and central nervous system manifestations of hepatoxicity including history of or on-going encephalopathy and severe symptoms and signs uncontrolled by medical or surgical treatment as evidenced by at least two of the following: - Albumin less than 28mg/L - INR greater than 2.20 - Bilirubin greater than 50μmol/l - Ascites.',
        Category:
            'Liver disease - Persistent jaundice and bleeding varies, hepatoxicity and severe symptoms and signs uncontrolled by medical or surgical treatment',
    },
    {
        value:
            'Lower gastrointestinal tract - Moderate to severe exacerbations with severe pain and symptoms and signs not completely controlled by medical or surgical treatment and weight loss resulting in a BMI of less than 16 due to disease.',
        label:
            'Lower gastrointestinal tract - Moderate to severe exacerbations with severe pain and symptoms and signs not completely controlled by medical or surgical treatment and weight loss resulting in a BMI of less than 16 due to disease.',
        Category:
            'Lower gastrointestinal tract - Moderate to severe exacerbations with severe pain and symptoms and signs not completely controlled by medical or surgical treatment and weight loss resulting in a BMI of less than 16 due to disease.',
    },
    {
        value:
            'Lower gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 14.5 due to disease.',
        label:
            'Lower gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 14.5 due to disease.',
        Category:
            'Lower gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 14.5 due to disease.',
    },
    {
        value:
            'Lower gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 15.5 due to disease.',
        label:
            'Lower gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 15.5 due to disease.',
        Category:
            'Lower gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 15.5 due to disease.',
    },
    {
        value:
            'Lumbar, thoracic and cervical spine - Bilateral involvement requiring use of assistive devices for hand function',
        label:
            'Lumbar, thoracic and cervical spine - Bilateral involvement requiring use of assistive devices for hand function',
        Category:
            'Lumbar, thoracic and cervical spine - Bilateral involvement requiring use of assistive devices for hand function',
    },
    {
        value:
            'Lumbar, thoracic and cervical spine - Radiculopathy and signs of chronic neurological impairment with special investigations changes and: cauda equine syndrome',
        label:
            'Lumbar, thoracic and cervical spine - Radiculopathy and signs of chronic neurological impairment with special investigations changes and: cauda equine syndrome',
        Category:
            'Lumbar, thoracic and cervical spine - Radiculopathy and signs of chronic neurological impairment with special investigations changes and: cauda equine syndrome',
    },
    {
        value:
            'Lumbar, thoracic and cervical spine - Radiculopathy and signs of chronic neurological impairment with special investigations changes and: unilateral involvement requiring use of assistive devices for hand function',
        label:
            'Lumbar, thoracic and cervical spine - Radiculopathy and signs of chronic neurological impairment with special investigations changes and: unilateral involvement requiring use of assistive devices for hand function',
        Category:
            'Lumbar, thoracic and cervical spine - Radiculopathy and signs of chronic neurological impairment with special investigations changes and: unilateral involvement requiring use of assistive devices for hand function',
    },
    {
        value: 'Lung cancer: Stage I',
        label: 'Lung cancer: Stage I',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage I',
        label: 'Lung cancer: Stage I',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage II',
        label: 'Lung cancer: Stage II',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage II',
        label: 'Lung cancer: Stage II',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage III',
        label: 'Lung cancer: Stage III',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage III',
        label: 'Lung cancer: Stage III',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage IV',
        label: 'Lung cancer: Stage IV',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lung cancer: Stage IV',
        label: 'Lung cancer: Stage IV',
        Category: 'Cancer and leukaemia - Lung cancer',
    },
    {
        value: 'Lymphoma: Hodgkins  lymphoma (Stage II on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins  lymphoma (Stage II on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Hodgkins  lymphoma (Stage II on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins  lymphoma (Stage II on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        label: 'Lymphoma: Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage I on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage II on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage II on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage II on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage II on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage III on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value: 'Lymphoma: Non-Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        label: 'Lymphoma: Non-Hodgkins lymphoma (Stage IV on Ann Arbor classification system)',
        Category: 'Cancer and leukaemia - Lymphoma',
    },
    {
        value:
            'Malignant melanoma with invasion beyond the epidermis or with a Breslow thickness of more than 1mm',
        label:
            'Malignant melanoma with invasion beyond the epidermis or with a Breslow thickness of more than 1mm',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value:
            'Malignant melanoma with invasion beyond the epidermis or with a Breslow thickness of more than 1mm',
        label:
            'Malignant melanoma with invasion beyond the epidermis or with a Breslow thickness of more than 1mm',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage I',
        label: 'Malignant melanoma: Stage I',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage I',
        label: 'Malignant melanoma: Stage I',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage II',
        label: 'Malignant melanoma: Stage II',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage II',
        label: 'Malignant melanoma: Stage II',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage III',
        label: 'Malignant melanoma: Stage III',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage III',
        label: 'Malignant melanoma: Stage III',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage IV',
        label: 'Malignant melanoma: Stage IV',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Malignant melanoma: Stage IV',
        label: 'Malignant melanoma: Stage IV',
        Category: 'Cancer and leukaemia - Malignant melanoma',
    },
    {
        value: 'Multiple myeloma: Stage I (R-ISS)',
        label: 'Multiple myeloma: Stage I (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple myeloma: Stage I (R-ISS)',
        label: 'Multiple myeloma: Stage I (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple myeloma: Stage II (R-ISS)',
        label: 'Multiple myeloma: Stage II (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple myeloma: Stage II (R-ISS)',
        label: 'Multiple myeloma: Stage II (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple myeloma: Stage III (R-ISS)',
        label: 'Multiple myeloma: Stage III (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value: 'Multiple myeloma: Stage III (R-ISS)',
        label: 'Multiple myeloma: Stage III (R-ISS)',
        Category: 'Cancer and leukaemia - Multiple myeloma',
    },
    {
        value:
            'Neurological impairment of respiration - Neurological impairment of respiration with permanent confinement to bed',
        label:
            'Neurological impairment of respiration - Neurological impairment of respiration with permanent confinement to bed',
        Category:
            'Neurological impairment of respiration - Neurological impairment of respiration with permanent confinement to bed',
    },
    {
        value:
            'Neurological impairment of respiration - Neurological impairment of respiration with permanent confinement to bed but not requiring ventilator assistance',
        label:
            'Neurological impairment of respiration - Neurological impairment of respiration with permanent confinement to bed but not requiring ventilator assistance',
        Category:
            'Neurological impairment of respiration - Neurological impairment of respiration with permanent confinement to bed but not requiring ventilator assistance',
    },
    {
        value:
            'Neurological impairment of respiration - No capacity for spontaneous respiration and requiring ventilation',
        label:
            'Neurological impairment of respiration - No capacity for spontaneous respiration and requiring ventilation',
        Category:
            'Neurological impairment of respiration - No capacity for spontaneous respiration and requiring ventilation',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Coronary artery disease - EF less than 35%',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Coronary artery disease - METS 2-5',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Coronary artery disease - METS less than 2',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Coronary artery disease - NYHA III',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Coronary artery disease - NYHA IV',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Diseases of the aorta - Persistent symptoms despite medication and NYHA IV',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: "Alzheimer's disease and progressive dementia",
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'AIDS',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Not applicable',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Oesophageal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Cervical',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Colorectal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Liver',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Lung',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Ovarian',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Pancreatic',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Renal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Stomach',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Thyroid',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Breast',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Prostate',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Bladder',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Endometrial',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Eye',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Metastatic',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Skin',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Testicular',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Tongue',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Uterus',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Other',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Oesophageal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Cervical',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Colorectal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Liver',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Lung',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Ovarian',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Pancreatic',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Renal',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Stomach',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Thyroid',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Breast',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Prostate',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Bladder',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Endometrial',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Eye',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Metastatic',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Skin',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Testicular',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Tongue',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Uterus',
    },
    {
        value: 'Not applicable',
        label: 'Not applicable',
        Category: 'Carcinoma-in-situ - Other',
    },
    {
        value: 'Oesophageal cancer: Stage I',
        label: 'Oesophageal cancer: Stage I',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage I',
        label: 'Oesophageal cancer: Stage I',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage II',
        label: 'Oesophageal cancer: Stage II',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage II',
        label: 'Oesophageal cancer: Stage II',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage III',
        label: 'Oesophageal cancer: Stage III',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage III',
        label: 'Oesophageal cancer: Stage III',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage IV',
        label: 'Oesophageal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value: 'Oesophageal cancer: Stage IV',
        label: 'Oesophageal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Oesophageal cancer',
    },
    {
        value:
            'Organic brain disorders and dementia - Clinical dementia due to an organic cause with two consecutive CDR 1.0 ratings and a Minimum Mental Score of 18 or less with the assessments being done at least two months apart',
        label:
            'Organic brain disorders and dementia - Clinical dementia due to an organic cause with two consecutive CDR 1.0 ratings and a Minimum Mental Score of 18 or less with the assessments being done at least two months apart',
        Category:
            'Organic brain disorders and dementia - Organic brain disorders and clinical dementia',
    },
    {
        value:
            'Organic brain disorders and dementia - Clinical dementia due to an organic cause with two consecutive CDR 2.0 ratings and a Mini Mental Score of 15 or less with the assessments being done at least two months apart.',
        label:
            'Organic brain disorders and dementia - Clinical dementia due to an organic cause with two consecutive CDR 2.0 ratings and a Mini Mental Score of 15 or less with the assessments being done at least two months apart.',
        Category:
            'Organic brain disorders and dementia - Organic brain disorders and clinical dementia',
    },
    {
        value:
            'Organic brain disorders and dementia - Clinical dementia due to an organic cause with two consecutive CDR 3.0 ratings and a Mini Mental Score of 13 or less with the assessments being done at least two months apart.',
        label:
            'Organic brain disorders and dementia - Clinical dementia due to an organic cause with two consecutive CDR 3.0 ratings and a Mini Mental Score of 13 or less with the assessments being done at least two months apart.',
        Category:
            'Organic brain disorders and dementia - Organic brain disorders and clinical dementia',
    },
    {
        value: 'Other cancer: Stage I',
        label: 'Other cancer: Stage I',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage I',
        label: 'Other cancer: Stage I',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage II',
        label: 'Other cancer: Stage II',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage II',
        label: 'Other cancer: Stage II',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage III',
        label: 'Other cancer: Stage III',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage III',
        label: 'Other cancer: Stage III',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage IV',
        label: 'Other cancer: Stage IV',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Other cancer: Stage IV',
        label: 'Other cancer: Stage IV',
        Category: 'Cancer and leukaemia - Other cancer',
    },
    {
        value: 'Ovarian cancer: Stage I',
        label: 'Ovarian cancer: Stage I',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage I',
        label: 'Ovarian cancer: Stage I',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage II',
        label: 'Ovarian cancer: Stage II',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage II',
        label: 'Ovarian cancer: Stage II',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage III',
        label: 'Ovarian cancer: Stage III',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage III',
        label: 'Ovarian cancer: Stage III',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage IV',
        label: 'Ovarian cancer: Stage IV',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Ovarian cancer: Stage IV',
        label: 'Ovarian cancer: Stage IV',
        Category: 'Cancer and leukaemia - Ovarian cancer',
    },
    {
        value: 'Pancreatic cancer: Stage I',
        label: 'Pancreatic cancer: Stage I',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage I',
        label: 'Pancreatic cancer: Stage I',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage II',
        label: 'Pancreatic cancer: Stage II',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage II',
        label: 'Pancreatic cancer: Stage II',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage III',
        label: 'Pancreatic cancer: Stage III',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage III',
        label: 'Pancreatic cancer: Stage III',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage IV',
        label: 'Pancreatic cancer: Stage IV',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Pancreatic cancer: Stage IV',
        label: 'Pancreatic cancer: Stage IV',
        Category: 'Cancer and leukaemia - Pancreatic cancer',
    },
    {
        value: 'Paralysis - Hemiplegia',
        label: 'Paralysis - Hemiplegia',
        Category: 'Paralysis - Hemiplegia',
    },
    {
        value: 'Paralysis - Paraplegia',
        label: 'Paralysis - Paraplegia',
        Category: 'Paralysis - Paraplegia',
    },
    {
        value: 'Paralysis - Quadriplegia',
        label: 'Paralysis - Quadriplegia',
        Category: 'Paralysis - Quadriplegia',
    },
    {
        value: 'Pericardial disease - EF 35-40%',
        label: 'Pericardial disease - EF 35-40%',
        Category: 'Pericardial disease - EF 35-40%',
    },
    {
        value: 'Pericardial disease - EF less than 35%',
        label: 'Pericardial disease - EF less than 35%',
        Category: 'Pericardial disease - EF less than 35%',
    },
    {
        value: 'Pericardial disease - EF less than 45%',
        label: 'Pericardial disease - EF less than 45%',
        Category: 'Pericardial disease - EF less than 45%',
    },
    {
        value: 'Pericardial disease - METS 2-5',
        label: 'Pericardial disease - METS 2-5',
        Category: 'Pericardial disease - METS 2-5',
    },
    {
        value: 'Pericardial disease - METS 5 or less',
        label: 'Pericardial disease - METS 5 or less',
        Category: 'Pericardial disease - METS 5 or less',
    },
    {
        value: 'Pericardial disease - METS less than 2',
        label: 'Pericardial disease - METS less than 2',
        Category: 'Pericardial disease - METS less than 2',
    },
    {
        value: 'Pericardial disease - NYHA III',
        label: 'Pericardial disease - NYHA III',
        Category: 'Pericardial disease - NYHA III',
    },
    {
        value: 'Pericardial disease - NYHA III or greater',
        label: 'Pericardial disease - NYHA III or greater',
        Category: 'Pericardial disease - NYHA III or greater',
    },
    {
        value: 'Pericardial disease - NYHA IV',
        label: 'Pericardial disease - NYHA IV',
        Category: 'Pericardial disease - NYHA IV',
    },
    {
        value:
            'Peripheral arterial disease - Abnormal diminished pulse on Doppler Readings and Cold leg and Pain on exercise',
        label:
            'Peripheral arterial disease - Abnormal diminished pulse on Doppler Readings and Cold leg and Pain on exercise',
        Category:
            'Peripheral arterial disease - Abnormal diminished pulse on Doppler Readings and Cold leg and Pain on exercise',
    },
    {
        value: 'Peripheral arterial disease - Gangrene',
        label: 'Peripheral arterial disease - Gangrene',
        Category: 'Peripheral arterial disease - Gangrene',
    },
    {
        value:
            'Peripheral arterial disease - Persistent ischaemia with no detectable pulse on Doppler readings',
        label:
            'Peripheral arterial disease - Persistent ischaemia with no detectable pulse on Doppler readings',
        Category:
            'Peripheral arterial disease - Persistent ischaemia with no detectable pulse on Doppler readings',
    },
    {
        value: 'Peripheral arterial disease - Severe vascular ulceration',
        label: 'Peripheral arterial disease - Severe vascular ulceration',
        Category: 'Peripheral arterial disease - Severe vascular ulceration',
    },
    {
        value: 'Peripheral venous disease - Severe, deep and widespread vascular ulceration',
        label: 'Peripheral venous disease - Severe, deep and widespread vascular ulceration',
        Category: 'Peripheral venous disease - Severe, deep and widespread vascular ulceration',
    },
    {
        value: 'Prostate - T1NOMO',
        label: 'Prostate - T1NOMO',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T1NOMO',
        label: 'Prostate - T1NOMO',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T1NOMO Gleason >7',
        label: 'Prostate - T1NOMO Gleason >7',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T1NOMO Gleason >7',
        label: 'Prostate - T1NOMO Gleason >7',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T2NOMO (any grade)',
        label: 'Prostate - T2NOMO (any grade)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T2NOMO (any grade)',
        label: 'Prostate - T2NOMO (any grade)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T3NOMO (any grade)',
        label: 'Prostate - T3NOMO (any grade)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value: 'Prostate - T3NOMO (any grade)',
        label: 'Prostate - T3NOMO (any grade)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value:
            'Prostate - T4NOMO (any grade) or Prostate Cancer with lymph node involvement or metastases (at least N1 in TNM classification system)',
        label:
            'Prostate - T4NOMO (any grade) or Prostate Cancer with lymph node involvement or metastases (at least N1 in TNM classification system)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value:
            'Prostate - T4NOMO (any grade) or Prostate Cancer with lymph node involvement or metastases (at least N1 in TNM classification system)',
        label:
            'Prostate - T4NOMO (any grade) or Prostate Cancer with lymph node involvement or metastases (at least N1 in TNM classification system)',
        Category: 'Cancer and leukaemia - Prostate',
    },
    {
        value:
            'Quadriplegia - Total loss or total loss of use of all four limbs due to a central nervous system disease, disorder or injury',
        label:
            'Quadriplegia - Total loss or total loss of use of all four limbs due to a central nervous system disease, disorder or injury',
        Category: 'Quadriplegia - Permanent quadriplegia',
    },
    {
        value: 'Renal cancer: Stage I',
        label: 'Renal cancer: Stage I',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage I',
        label: 'Renal cancer: Stage I',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage II',
        label: 'Renal cancer: Stage II',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage II',
        label: 'Renal cancer: Stage II',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage III',
        label: 'Renal cancer: Stage III',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage III',
        label: 'Renal cancer: Stage III',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage IV',
        label: 'Renal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'Renal cancer: Stage IV',
        label: 'Renal cancer: Stage IV',
        Category: 'Cancer and leukaemia - Renal cancer',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage I',
        label: 'SCC: Squamous cell skin carcinoma: Stage I',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage I',
        label: 'SCC: Squamous cell skin carcinoma: Stage I',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage II',
        label: 'SCC: Squamous cell skin carcinoma: Stage II',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage II',
        label: 'SCC: Squamous cell skin carcinoma: Stage II',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage III',
        label: 'SCC: Squamous cell skin carcinoma: Stage III',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage III',
        label: 'SCC: Squamous cell skin carcinoma: Stage III',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage IV',
        label: 'SCC: Squamous cell skin carcinoma: Stage IV',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value: 'SCC: Squamous cell skin carcinoma: Stage IV',
        label: 'SCC: Squamous cell skin carcinoma: Stage IV',
        Category: 'Cancer and leukaemia - SCC',
    },
    {
        value:
            'Schizophrenia/other pyschotic disorders - Institutionalised at least 3 times in the last 12 months with each admission lasting for longer than 6 weeks and GAF less than 40.',
        label:
            'Schizophrenia/other pyschotic disorders - Institutionalised at least 3 times in the last 12 months with each admission lasting for longer than 6 weeks and GAF less than 40.',
        Category:
            'Schizophrenia/other pyschotic disorders - Institutionalised at least 3 times in the last 12 months with each admission lasting for longer than 6 weeks and GAF less than 40.',
    },
    {
        value:
            'Schizophrenia/other pyschotic disorders - Requiring permanent institutionalisation or permanent caregiver and GAF less than 30',
        label:
            'Schizophrenia/other pyschotic disorders - Requiring permanent institutionalisation or permanent caregiver and GAF less than 30',
        Category:
            'Schizophrenia/other pyschotic disorders - Requiring permanent institutionalisation or permanent caregiver and GAF less than 30',
    },
    {
        value: 'Skin cancer: Stage I',
        label: 'Skin cancer: Stage I',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage I',
        label: 'Skin cancer: Stage I',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage II',
        label: 'Skin cancer: Stage II',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage II',
        label: 'Skin cancer: Stage II',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage III',
        label: 'Skin cancer: Stage III',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage III',
        label: 'Skin cancer: Stage III',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage IV',
        label: 'Skin cancer: Stage IV',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value: 'Skin cancer: Stage IV',
        label: 'Skin cancer: Stage IV',
        Category: 'Cancer and leukaemia - Skin cancer',
    },
    {
        value:
            'Sleep disorders - Documented prolonged sleep disorder with interruption to, or shortening of normal sleep cycles, resulting in cognitive deterioration over time and persistent inappropriate daytime fatigue and impaired concentration and documented cataplexy occurring 3 or more times daily and completely housebound.',
        label:
            'Sleep disorders - Documented prolonged sleep disorder with interruption to, or shortening of normal sleep cycles, resulting in cognitive deterioration over time and persistent inappropriate daytime fatigue and impaired concentration and documented cataplexy occurring 3 or more times daily and completely housebound.',
        Category: 'Sleep disorders - Essential narcolepsy',
    },
    {
        value:
            'Sleep disorders - Documented prolonged sleep disorder with interruption to, or shortening of normal sleep cycles, resulting in cognitive deterioration over time and persistent inappropriate daytime fatigue and impaired concentration and documented cataplexy occurring daily',
        label:
            'Sleep disorders - Documented prolonged sleep disorder with interruption to, or shortening of normal sleep cycles, resulting in cognitive deterioration over time and persistent inappropriate daytime fatigue and impaired concentration and documented cataplexy occurring daily',
        Category: 'Sleep disorders - Essential narcolepsy',
    },
    {
        value: 'Stomach cancer: Stage I',
        label: 'Stomach cancer: Stage I',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage I',
        label: 'Stomach cancer: Stage I',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage II',
        label: 'Stomach cancer: Stage II',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage II',
        label: 'Stomach cancer: Stage II',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage III',
        label: 'Stomach cancer: Stage III',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage III',
        label: 'Stomach cancer: Stage III',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage IV',
        label: 'Stomach cancer: Stage IV',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value: 'Stomach cancer: Stage IV',
        label: 'Stomach cancer: Stage IV',
        Category: 'Cancer and leukaemia - Stomach cancer',
    },
    {
        value:
            'Stroke (cerebrovascular incident) - Either four of the following: Moderate communication difficulties, Moderate difficulties with posture and motion, Moderate difficulties with fine and gross motor functions, Moderate cognitive problems, or Homonymous Hemianopia',
        label:
            'Stroke (cerebrovascular incident) - Either four of the following: Moderate communication difficulties, Moderate difficulties with posture and motion, Moderate difficulties with fine and gross motor functions, Moderate cognitive problems, or Homonymous Hemianopia',
        Category:
            'Stroke (cerebrovascular incident) - Either four of the following: Moderate communication difficulties, Moderate difficulties with posture and motion, Moderate difficulties with fine and gross motor functions, Moderate cognitive problems, or Homonymous Hemianopia',
    },
    {
        value:
            'Stroke (cerebrovascular incident) - The inability to perform any one of the following categories: Moderate communication difficulties, Moderate difficulties with posture and motion, Moderate difficulties with fine and gross motor functions, or Moderate cognitive problems',
        label:
            'Stroke (cerebrovascular incident) - The inability to perform any one of the following categories: Moderate communication difficulties, Moderate difficulties with posture and motion, Moderate difficulties with fine and gross motor functions, or Moderate cognitive problems',
        Category:
            'Stroke (cerebrovascular incident) - The inability to perform any one of the following categories: Moderate communication difficulties, Moderate difficulties with posture and motion, Moderate difficulties with fine and gross motor functions, or Moderate cognitive problems',
    },
    {
        value: 'Testicular cancer: Stage I',
        label: 'Testicular cancer: Stage I',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage I',
        label: 'Testicular cancer: Stage I',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage II',
        label: 'Testicular cancer: Stage II',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage II',
        label: 'Testicular cancer: Stage II',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage III',
        label: 'Testicular cancer: Stage III',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage III',
        label: 'Testicular cancer: Stage III',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage IV',
        label: 'Testicular cancer: Stage IV',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value: 'Testicular cancer: Stage IV',
        label: 'Testicular cancer: Stage IV',
        Category: 'Cancer and leukaemia - Testicular cancer',
    },
    {
        value:
            'The endocrine system - Symptoms and signs of abnormality of the endocrine system leading to targer end-organ damage despite appropriate surgical and medical treatment including replacement or blockades',
        label:
            'The endocrine system - Symptoms and signs of abnormality of the endocrine system leading to targer end-organ damage despite appropriate surgical and medical treatment including replacement or blockades',
        Category:
            'The endocrine system - Symptoms and signs of abnormality of the endocrine system leading to targer end-organ damage despite appropriate surgical and medical treatment including replacement or blockades',
    },
    {
        value:
            'The limbs - At least 2 of the following: - Hand at MP joint, Arm below the elbow, - Arm above the elbow, - Leg through the hip, - Leg above the knee, - Leg below the knee',
        label:
            'The limbs - At least 2 of the following: - Hand at MP joint, Arm below the elbow, - Arm above the elbow, - Leg through the hip, - Leg above the knee, - Leg below the knee',
        Category:
            'The limbs - At least 2 of the following: Hand at MP joint, Arm below the elbow, Arm above the elbow, Leg through the hip, Leg above the knee, Leg below the knee',
    },
    {
        value: 'The limbs - Hemipelvectomy',
        label: 'The limbs - Hemipelvectomy',
        Category: 'The limbs - Hemipelvectomy',
    },
    {
        value: 'The limbs - Loss of or loss of use foot',
        label: 'The limbs - Loss of or loss of use foot',
        Category: 'The limbs - Loss of or loss of use of foot',
    },
    {
        value: 'The limbs - Loss of or loss of use of arm below the elbow',
        label: 'The limbs - Loss of or loss of use of arm below the elbow',
        Category: 'The limbs - Loss of or loss of use of arm below the elbow',
    },
    {
        value: 'The limbs - Loss of or loss of use of arm below the shoulder',
        label: 'The limbs - Loss of or loss of use of arm below the shoulder',
        Category: 'The limbs - Loss of or loss of use of arm below the shoulder',
    },
    {
        value: 'The limbs - Loss of or loss of use of hand at MP joint',
        label: 'The limbs - Loss of or loss of use of hand at MP joint',
        Category: 'The limbs - Loss of or loss of use of hand at MP joint',
    },
    {
        value: 'The limbs - Loss of or loss of use of leg above the kness',
        label: 'The limbs - Loss of or loss of use of leg above the kness',
        Category: 'The limbs - Loss of or loss of use of leg above the kness',
    },
    {
        value: 'The limbs - Loss of or loss of use of leg below the knee',
        label: 'The limbs - Loss of or loss of use of leg below the knee',
        Category: 'The limbs - Loss of or loss of use of leg below the knee',
    },
    {
        value: 'The limbs - Loss of or loss of use of leg through the hip',
        label: 'The limbs - Loss of or loss of use of leg through the hip',
        Category: 'The limbs - Loss of or loss of use of leg through the hip',
    },
    {
        value: 'The limbs - Loss of or loss of use of thumb through MP joint',
        label: 'The limbs - Loss of or loss of use of thumb through MP joint',
        Category: 'The limbs - Loss of or loss of use of thumb through MP joint',
    },
    {
        value: 'The respiratory system - DCO less than 40% of predicted',
        label: 'The respiratory system - DCO less than 40% of predicted',
        Category: 'The respiratory system - DCO less than 40% of predicted',
    },
    {
        value: 'The respiratory system - DCO less than 60% of predicted',
        label: 'The respiratory system - DCO less than 60% of predicted',
        Category: 'The respiratory system - DCO less than 60% of predicted',
    },
    {
        value: 'The respiratory system - DCO of 40 - 59% of predicted',
        label: 'The respiratory system - DCO of 40 - 59% of predicted',
        Category: 'The respiratory system - DCO of 40 - 59% of predicted',
    },
    {
        value: 'The respiratory system - FEV1 less than 40% of predicted',
        label: 'The respiratory system - FEV1 less than 40% of predicted',
        Category: 'The respiratory system - FEV1 less than 40% of predicted',
    },
    {
        value: 'The respiratory system - FEV1 less than 60% of predicted',
        label: 'The respiratory system - FEV1 less than 60% of predicted',
        Category: 'The respiratory system - FEV1 less than 60% of predicted',
    },
    {
        value: 'The respiratory system - FEV1 of 40 - 59% of predicted',
        label: 'The respiratory system - FEV1 of 40 - 59% of predicted',
        Category: 'The respiratory system - FEV1 of 40 - 59% of predicted',
    },
    {
        value: 'The respiratory system - FVC less than 40% of predicted',
        label: 'The respiratory system - FVC less than 40% of predicted',
        Category: 'The respiratory system - FVC less than 40% of predicted',
    },
    {
        value: 'The respiratory system - FVC less than 60% of predicted',
        label: 'The respiratory system - FVC less than 60% of predicted',
        Category: 'The respiratory system - FVC less than 60% of predicted',
    },
    {
        value: 'The respiratory system - FVC of 40 - 49% of predicted',
        label: 'The respiratory system - FVC of 40 - 49% of predicted',
        Category: 'The respiratory system - FVC of 40 - 49% of predicted',
    },
    {
        value: 'The respiratory system - FVC of 50 - 59% of predicted',
        label: 'The respiratory system - FVC of 50 - 59% of predicted',
        Category: 'The respiratory system - FVC of 50 - 59% of predicted',
    },
    {
        value:
            'The skin - Extensive permanent involvement of an upper and lower limb including the sole of one foot and the palm of one hand',
        label:
            'The skin - Extensive permanent involvement of an upper and lower limb including the sole of one foot and the palm of one hand',
        Category:
            'The skin - Extensive permanent involvement of an upper and lower limb including the sole of one foot and the palm of one hand',
    },
    {
        value:
            'The skin - Extensive permanent involvement of the bilateral lower limbs including the soles of both feet',
        label:
            'The skin - Extensive permanent involvement of the bilateral lower limbs including the soles of both feet',
        Category:
            'The skin - Extensive permanent involvement of the bilateral lower limbs including the soles of both feet',
    },
    {
        value:
            'The skin - Extensive permanent involvement of the bilateral upper limbs including the palms of both hands',
        label:
            'The skin - Extensive permanent involvement of the bilateral upper limbs including the palms of both hands',
        Category:
            'The skin - Extensive permanent involvement of the bilateral upper limbs including the palms of both hands',
    },
    {
        value:
            'The skin - Extensive permanent involvement of the bilateral upper limbs including the palms of both hands and restriction of joint mobility',
        label:
            'The skin - Extensive permanent involvement of the bilateral upper limbs including the palms of both hands and restriction of joint mobility',
        Category:
            'The skin - Extensive permanent involvement of the bilateral upper limbs including the palms of both hands and restriction of joint mobility',
    },
    {
        value:
            'The skin - Third degree burns involving more than 20% of the total body surface area',
        label:
            'The skin - Third degree burns involving more than 20% of the total body surface area',
        Category:
            'The skin - Third degree burns involving more than 20% of the total body surface area',
    },
    {
        value:
            'The skin - Third degree burns involving more than 30% of the total body surface area',
        label:
            'The skin - Third degree burns involving more than 30% of the total body surface area',
        Category:
            'The skin - Third degree burns involving more than 30% of the total body surface area',
    },
    {
        value: 'The visual system - Diabetic retinopathy grade III',
        label: 'The visual system - Diabetic retinopathy grade III',
        Category: 'The visual system - Diabetic retinopathy',
    },
    {
        value: 'The visual system - Diabetic retinopathy grade IV',
        label: 'The visual system - Diabetic retinopathy grade IV',
        Category: 'The visual system - Diabetic retinopathy',
    },
    {
        value: 'The visual system - Irreversible hemianopia in both eyes',
        label: 'The visual system - Irreversible hemianopia in both eyes',
        Category: 'The visual system - Hemianopia',
    },
    {
        value: 'The visual system - Irreversible hemianopia in one eye',
        label: 'The visual system - Irreversible hemianopia in one eye',
        Category: 'The visual system - Hemianopia',
    },
    {
        value:
            'The visual system - Irreversible visual acuity impairment, not correctable by operation resulting in a Snellen rating of less than 20/200 in both eyes',
        label:
            'The visual system - Irreversible visual acuity impairment, not correctable by operation resulting in a Snellen rating of less than 20/200 in both eyes',
        Category: 'The visual system - Irreversible visual acuity impairment',
    },
    {
        value:
            'The visual system - Irreversible visual acuity impairment, not correctable by operation, resulting in a Snellen rating of less than 20/125 in both eyes',
        label:
            'The visual system - Irreversible visual acuity impairment, not correctable by operation, resulting in a Snellen rating of less than 20/125 in both eyes',
        Category: 'The visual system - Irreversible visual acuity impairment',
    },
    {
        value:
            'The visual system - Irreversible visual acuity impairment, not correctable by operation, resulting in a Snellen rating of less than 20/200 in one eye',
        label:
            'The visual system - Irreversible visual acuity impairment, not correctable by operation, resulting in a Snellen rating of less than 20/200 in one eye',
        Category: 'The visual system - Irreversible visual acuity impairment',
    },
    {
        value: 'Thyroid cancer: Stage I',
        label: 'Thyroid cancer: Stage I',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage I',
        label: 'Thyroid cancer: Stage I',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage II',
        label: 'Thyroid cancer: Stage II',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage II',
        label: 'Thyroid cancer: Stage II',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage III',
        label: 'Thyroid cancer: Stage III',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage III',
        label: 'Thyroid cancer: Stage III',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage IV',
        label: 'Thyroid cancer: Stage IV',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Thyroid cancer: Stage IV',
        label: 'Thyroid cancer: Stage IV',
        Category: 'Cancer and leukaemia - Thyroid cancer',
    },
    {
        value: 'Tongue cancer: Stage I',
        label: 'Tongue cancer: Stage I',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage I',
        label: 'Tongue cancer: Stage I',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage II',
        label: 'Tongue cancer: Stage II',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage II',
        label: 'Tongue cancer: Stage II',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage III',
        label: 'Tongue cancer: Stage III',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage III',
        label: 'Tongue cancer: Stage III',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage IV',
        label: 'Tongue cancer: Stage IV',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Tongue cancer: Stage IV',
        label: 'Tongue cancer: Stage IV',
        Category: 'Cancer and leukaemia - Tongue cancer',
    },
    {
        value: 'Upper air passages - Dyspnoea at rest and NYHA IV',
        label: 'Upper air passages - Dyspnoea at rest and NYHA IV',
        Category: 'Upper air passages - Dyspnoea',
    },
    {
        value: 'Upper air passages - Dyspnoea at rest and respiratory ventilation is required',
        label: 'Upper air passages - Dyspnoea at rest and respiratory ventilation is required',
        Category: 'Upper air passages - Dyspnoea',
    },
    {
        value: 'Upper air passages - Dyspnoea on moderate effort and NYHA III',
        label: 'Upper air passages - Dyspnoea on moderate effort and NYHA III',
        Category: 'Upper air passages - Dyspnoea',
    },
    {
        value: 'Upper air passages - Dyspnoea on moderate effort and NYHA III or greater',
        label: 'Upper air passages - Dyspnoea on moderate effort and NYHA III or greater',
        Category: 'Upper air passages - Dyspnoea',
    },
    {
        value:
            'Upper gastrointestinal tract - Moderate to severe exacerbations with severe pain and symptoms and signs not completely controlled by medical or surgical treatment and weight loss resulting in a BMI of less than 16 due to disease.',
        label:
            'Upper gastrointestinal tract - Moderate to severe exacerbations with severe pain and symptoms and signs not completely controlled by medical or surgical treatment and weight loss resulting in a BMI of less than 16 due to disease.',
        Category:
            'Upper gastrointestinal tract - Moderate to severe exacerbations with severe pain and symptoms and signs not completely controlled by medical or surgical treatment and weight loss resulting in a BMI of less than 16 due to disease.',
    },
    {
        value:
            'Upper gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 14.5 due to disease.',
        label:
            'Upper gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 14.5 due to disease.',
        Category:
            'Upper gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 14.5 due to disease.',
    },
    {
        value:
            'Upper gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 15.5 due to disease.',
        label:
            'Upper gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 15.5 due to disease.',
        Category:
            'Upper gastrointestinal tract - Unremitting severe symptoms and signs uncontrolled by medical or surgical treatment and weight loss resulting in a BMI of less than 15.5 due to disease.',
    },
    {
        value:
            'Upper urinary tract - Irreversible kidney failure with GFR 24-40ml/min despite treatment',
        label:
            'Upper urinary tract - Irreversible kidney failure with GFR 24-40ml/min despite treatment',
        Category:
            'Upper urinary tract - Irreversible kidney failure with GFR 24-40ml/min despite treatment',
    },
    {
        value:
            'Upper urinary tract - Irreversible kidney failure with GFR less than 24ml/min despite treatment',
        label:
            'Upper urinary tract - Irreversible kidney failure with GFR less than 24ml/min despite treatment',
        Category:
            'Upper urinary tract - Irreversible kidney failure with GFR less than 24ml/min despite treatment',
    },
    {
        value:
            'Upper urinary tract - Irreversible kidney failure with GFR less than 40ml/min despite treatment',
        label:
            'Upper urinary tract - Irreversible kidney failure with GFR less than 40ml/min despite treatment',
        Category:
            'Upper urinary tract - Irreversible kidney failure with GFR less than 40ml/min despite treatment',
    },
    {
        value: 'Upper urinary tract - Requires ongoing dialysis',
        label: 'Upper urinary tract - Requires ongoing dialysis',
        Category: 'Upper urinary tract - Requires ongoing dialysis',
    },
    {
        value:
            'Urethra - Urethral dysfunction and loss of voluntary urine control and requiring an indwelling catheter.',
        label:
            'Urethra - Urethral dysfunction and loss of voluntary urine control and requiring an indwelling catheter.',
        Category:
            'Urethra - Urethral dysfunction and loss of voluntary urine control and requiring an indwelling catheter.',
    },
    {
        value: 'Uterus cancer: Stage I',
        label: 'Uterus cancer: Stage I',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage I',
        label: 'Uterus cancer: Stage I',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage II',
        label: 'Uterus cancer: Stage II',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage II',
        label: 'Uterus cancer: Stage II',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage III',
        label: 'Uterus cancer: Stage III',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage III',
        label: 'Uterus cancer: Stage III',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage IV',
        label: 'Uterus cancer: Stage IV',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Uterus cancer: Stage IV',
        label: 'Uterus cancer: Stage IV',
        Category: 'Cancer and leukaemia - Uterus cancer',
    },
    {
        value: 'Valvular heart disease - EF 35-40%',
        label: 'Valvular heart disease - EF 35-40%',
        Category: 'Valvular heart disease - EF 35-40%',
    },
    {
        value: 'Valvular heart disease - EF less than 35%',
        label: 'Valvular heart disease - EF less than 35%',
        Category: 'Valvular heart disease - EF less than 35%',
    },
    {
        value: 'Valvular heart disease - EF less than 45%',
        label: 'Valvular heart disease - EF less than 45%',
        Category: 'Valvular heart disease - EF less than 45%',
    },
    {
        value: 'Valvular heart disease - METS 2-5',
        label: 'Valvular heart disease - METS 2-5',
        Category: 'Valvular heart disease - METS 2-5',
    },
    {
        value: 'Valvular heart disease - METS 5 or less',
        label: 'Valvular heart disease - METS 5 or less',
        Category: 'Valvular heart disease - METS 5 or less',
    },
    {
        value: 'Valvular heart disease - METS less than 2',
        label: 'Valvular heart disease - METS less than 2',
        Category: 'Valvular heart disease - METS less than 2',
    },
    {
        value: 'Valvular heart disease - NYHA III',
        label: 'Valvular heart disease - NYHA III',
        Category: 'Valvular heart disease - NYHA III',
    },
    {
        value: 'Valvular heart disease - NYHA III or greater',
        label: 'Valvular heart disease - NYHA III or greater',
        Category: 'Valvular heart disease - NYHA III or greater',
    },
    {
        value: 'Valvular heart disease - NYHA IV',
        label: 'Valvular heart disease - NYHA IV',
        Category: 'Valvular heart disease - NYHA IV',
    },
    {
        value:
            'Vestibular disorders - With frequent attacks of nausea, vomiting, vertigo and dizziness lasting more than 3 hours per episode, with at least 10 episodes per month.',
        label:
            'Vestibular disorders - With frequent attacks of nausea, vomiting, vertigo and dizziness lasting more than 3 hours per episode, with at least 10 episodes per month.',
        Category: 'Vestibular disorders - Vestibular dyequilibrium',
    },
    {
        value:
            'Vestibular disorders - With permanent failure of any of the following functions, namely: walking, standing, stooping, squatting, kneeling, climbing stairs and completely housebound',
        label:
            'Vestibular disorders - With permanent failure of any of the following functions, namely: walking, standing, stooping, squatting, kneeling, climbing stairs and completely housebound',
        Category: 'Vestibular disorders - Vestibular dyequilibrium',
    },
    {
        value: 'Voice/speech impairment - Failure of all three functions',
        label: 'Voice/speech impairment - Failure of all three functions',
        Category: 'Voice/speech impairment - Failure of all three functions',
    },
    {
        value: 'Voice/speech impairment - Failure of all three moderate functions',
        label: 'Voice/speech impairment - Failure of all three moderate functions',
        Category: 'Voice/speech impairment - Failure of all three moderate functions',
    },
    {
        value: 'Voice/speech impairment - Failure of all three severe functions',
        label: 'Voice/speech impairment - Failure of all three severe functions',
        Category: 'Voice/speech impairment - Failure of all three severe functions',
    },
    {
        value:
            'Voice/speech impairment - Total and permanent loss of the ability to speak as confirmed by an appropriate specialist',
        label:
            'Voice/speech impairment - Total and permanent loss of the ability to speak as confirmed by an appropriate specialist',
        Category:
            'Voice/speech impairment - Total and permanent loss of the ability to speak as confirmed by an appropriate specialist',
    },
    {
        value:
            'White blood cells - Marked physical weakness despite treatment and - Leukaemia requiring chemotherapy 3 to 6 times in the last 12 months and - Granulocyte count consistently below 0.5 x 10*9/L with at least two documented community acquired or opportunistic infections',
        label:
            'White blood cells - Marked physical weakness despite treatment and - Leukaemia requiring chemotherapy 3 to 6 times in the last 12 months and - Granulocyte count consistently below 0.5 x 10*9/L with at least two documented community acquired or opportunistic infections',
        Category: 'White blood cells - Leukaemia, lymphoma and white cell abnormalities',
    },
    {
        value:
            'White blood cells - Marked physical weakness despite treatment and - Leukaemia requiring chemotherapy 3 to 6 times in the last 12 months and - Granulocyte count consistently below 0.5 x 10*9/L, with more than one life-threatening infection requiring hospitalisation in the last 12 months.',
        label:
            'White blood cells - Marked physical weakness despite treatment and - Leukaemia requiring chemotherapy 3 to 6 times in the last 12 months and - Granulocyte count consistently below 0.5 x 10*9/L, with more than one life-threatening infection requiring hospitalisation in the last 12 months.',
        Category: 'White blood cells - Leukaemia, lymphoma and white cell abnormalities',
    },
    {
        value:
            'White blood cells - Terminal condition causing severe impairment and - Leukaemia requiring chemotherapy more than 6 times in the last 12 months and - Granulocyte count consistently below 0.5 x 10*9/L, with more than one life-threatening infection requiring hospitalisation in the last 12 months.',
        label:
            'White blood cells - Terminal condition causing severe impairment and - Leukaemia requiring chemotherapy more than 6 times in the last 12 months and - Granulocyte count consistently below 0.5 x 10*9/L, with more than one life-threatening infection requiring hospitalisation in the last 12 months.',
        Category: 'White blood cells - Leukaemia, lymphoma and white cell abnormalities',
    },
];
